export default function() {
    this.loadMessages()

    this.$root.$emit('messagesOpened')
}